import { IsArray, IsString } from 'class-validator';

export class ProvisionIntegrationFlowsDto {
	@IsArray()
	@IsString({ each: true })
	public tenantAliases!: Array<string>;
}
